import { defineComponent } from "vue";
import { mapState } from "pinia";
import moment from "moment";
import { Container } from "aurelia-dependency-injection";
import useVuelidate from "@vuelidate/core";
import { required, requiredIf } from "@vuelidate/validators";

import { enumToMap } from "../../../../../../common/vue-helpers/modifiers/enum-modifiers";
import { AdmissionSources, AdmissionTypes, PermissionActionEnum, PhoneTypeEnum } from "../../../../../../enums/enums";
import { PriorHospice } from "../../../../../../resources-vue/vue-models/prior-hospice";
import { useHospiceConvertToPending } from "../../../store/useHospiceConvertToPending";
import { EnumsService } from "../../../../../../services/enums.service";
import { HospiceConvertToPendingPatient } from "../../../../../../resources-vue/vue-models/hospice-convertToPending-details";
import { PermissionManager } from "../../../../../../common/utilities/permission-manager";

import FormSection from "../../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import HospiceTransferForm from "./HospiceTransferForm/HospiceTransferForm.vue";

export default defineComponent({
    inject: ["v"],
    components: {
        FormSection,
        HospiceTransferForm
    },

    props: {
        showBenefitPeriodManager: {
            type: Boolean,
            default: false
        },
        isReadOnly: {
            type: Boolean
        }
    },

    validations() {
        return {
            patientDetails: {
                admissionType: { required },
                admissionSource: { required },
                benefitPeriodNumber: { required: requiredIf(!this.patientDetails.isTransfer) }
            }
        };
    },

    data() {
        return {
            _permissionManager: null,
            _enumsService: null,
            benefitPeriodStartDate: "" as string,
            homePhoneNumberOptions: [PhoneTypeEnum.Home] as Array<string>,
            hasViewBenefitPeriodPermission: false as boolean,
            AdmissionSources: AdmissionSources,
            AdmissionTypes: AdmissionTypes,
            patientStatusEnums: [],
            v$: this.v,
            enumToMap
        };
    },

    created() {
        this._enumsService = Container.instance.get(EnumsService);
        this._permissionManager = Container.instance.get(PermissionManager);
    },

    async mounted() {
        // uncomment once permission endpoint is updated with below permissions
        // this.hasViewBenefitPeriodPermission = this._permissionManager.checkPermission([
        //     {
        //         resource: ClinicalPermissionEnum.ManageBenefitPeriod,
        //         action: PermissionActionEnum.canView
        //     }
        // ]);
        if (!!this.patientDetails && !!this.patientDetails.priorHospice) {
            this.benefitPeriodStartDate = this.patientDetails.priorHospice.benefitPeriodStartDate;
        }
        let patientStatusEnums = await this._enumsService.getPatientStatus();
        this.patientStatusEnums = patientStatusEnums.getJson();
    },
    computed: {
        benefitPeriodEndDate() {
            let result;
            if (
                this.benefitPeriodStartDate &&
                this.patientDetails &&
                Number(this.patientDetails.benefitPeriodNumber) > 0
            ) {
                const endDate = moment(this.benefitPeriodStartDate).add(59, "days");
                if (Number(this.patientDetails.benefitPeriodNumber) <= 2) {
                    endDate.add(30, "days");
                }
                result = endDate.format("MM/DD/YYYY");
                this.patientDetails.priorHospice.benefitPeriodEndDate = result;
            }
            return result;
        },
        isPendingStatus() {
            return this.patientStatusEnums.some((status) => status.value === this.patientDetails.status);
        },
        enableAdmissionBenefitPeriod() {
            return (
                this.isPendingStatus &&
                !(this.patientDetails as HospiceConvertToPendingPatient).patientTransferTypeChanged
            );
        },
        ...mapState(useHospiceConvertToPending, ["patientDetails", "application"])
    },
    methods: {
        handleAdmissionSourceTypeSelection() {
            this.patientDetails.isTransfer = !this.patientDetails.isTransfer;
            if (this.patientDetails.isTransfer) {
                this.patientDetails.priorHospice = new PriorHospice();
                this.benefitPeriodStartDate = this.patientDetails.priorHospice.benefitPeriodStartDate;
            }
        },
        handleBenfitPeriodStartDate(date: any, name: any) {
            if (name === "benefitPeriodStartDate") {
                this.benefitPeriodStartDate = date;
                this.patientDetails.priorHospice.benefitPeriodStartDate = this.benefitPeriodStartDate;
            }
        },
        handlePreviousAdmissionChange(value: boolean) {
            this.patientDetails.previousHospiceAdmission = value;
        }
    }
});
